import { showSuccessToast, showErrorToast } from "utils/toast";
import {
  useGetUserTransmissionProgressReportMutation,
  useGetTransmissionProgressAnalyticsUsersQuery,
} from "app/store/userActivityLog/api/userActivityLogApi";
import { downloadFile } from "app/utils/file";

const useUserTransmissionProgressReportForm = ({ onClose }) => {
  const { data: users = [] } = useGetTransmissionProgressAnalyticsUsersQuery();
  const [getUserTransmissionProgressReport, { isLoading: isDownloading }] =
    useGetUserTransmissionProgressReportMutation();

  const downloadUserTransmissionProgressReport = async (values) => {
    try {
      const response = await getUserTransmissionProgressReport({
        users: values.users,
        startDate: values.startDate,
        endDate: values.endDate,
      });

      if (response.error) {
        throw response.error;
      }

      const { data, filename } = response?.data || {};

      if (data && filename) {
        downloadFile(response.data, filename);
        showSuccessToast(
          "Transmission Progress Report downloaded successfully."
        );
        onClose();
      } else {
        showSuccessToast(response?.data?.message);
      }
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  return {
    users,
    isDownloading,
    downloadUserTransmissionProgressReport,
  };
};

export default useUserTransmissionProgressReportForm;
